module.exports = __webpack_public_path__ + "img/612-42dfb3.png";